import { ComponentType, lazy } from 'react'

import { IActionType } from '@makyoapp/makyo-common'

import { PanelProps } from './panel.type'

const PanelTemporaryVariable = lazy(() => import('./Panel.TemporaryVariable'))
const PanelFilterData = lazy(() => import('./Panel.FilterData'))

type PanelsMap = {
  [IActionType.TemporaryVariable]: ComponentType<PanelProps>
  [IActionType.FilterData]: ComponentType<PanelProps>
}

export const PanelsMap = {
  [IActionType.TemporaryVariable]: PanelTemporaryVariable,
  [IActionType.FilterData]: PanelFilterData,
}
